module.exports = __webpack_public_path__ + "img/img_applicable_02.5e683643.png";